/**
 * 不支持 嵌套打开
 */
import { App, render, createVNode } from 'vue';
import MicroDrawer from './index.vue';

// 创建默认参数
const defaultOpt = {
  type: 'success',
};

let container: HTMLDivElement | null = null;
let vNode: any | null = null;

// 创建挂载实例
const getInstance = (opts?: { [key: string]: any }) => {
  if (!vNode) {
    // 创建一个 div 容器, 把容器渲染到 body 上
    vNode = createVNode(MicroDrawer, opts);
    if (!container) {
      container = document.createElement('div');
      document.body.appendChild(container);
    }
    // 把实例 render 到容器上
    render(vNode, container);
  }
  return vNode;
};

function Drawer(opts?: { [key: string]: any }) {
  getInstance().component?.exposed?.openDrawer(opts);
}
Drawer.install = (app: App<Element>) => {
  app.component('microDrawer', MicroDrawer);
  app.provide('Drawer', Drawer);
  app.config.globalProperties.$microDrawer = Drawer;
};

Drawer.open = (opts?: { [key: string]: any }) => {
  console.log('drawer open opts', opts);
  getInstance().component?.exposed?.openDrawer(opts);
};

Drawer.close = () => {
  getInstance().component?.exposed?.onClose();
};
Drawer.unfold = () => {
  getInstance().component?.exposed?.onUnfold();
};

Drawer.fold = () => {
  getInstance().component?.exposed?.onFold();
};

Drawer.getVisible = () => {
  return getInstance().component?.exposed?.getVisible();
};

/**
 * @description: 销毁 body 上的 实例
 * @param {HTMLDivElement} ele
 * @return {*}
 */
Drawer.remove = (ele?: HTMLDivElement): void => {
  if (container) {
    render(null, container);
    document.body.removeChild(container);
  }
};

export default Drawer;
